<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="wksDeliveries"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-upload
            :action="uploadUrlExcel"
            :headers="uploadHeaders"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="success">标准excel导入</el-button>
        </el-upload>
        <el-upload
            :action="uploadUrlExcelByFB"
            :headers="uploadHeaders"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="info">非标准excel导入</el-button>
        </el-upload>
        <el-button type="primary" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="datetime"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="项目号">
            <el-input v-model.trim="filter.projectNo" clearable/>
          </vm-search>
          <vm-search label="产品类型">
            <el-input v-model.trim="filter.projectType" clearable/>
          </vm-search>
          <vm-search label="包装">
            <el-input v-model.trim="filter.packStatus" clearable/>
          </vm-search>

          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="projectNo" align="center" width="120" label="项目号">
        <template slot-scope="scope">
          <span v-if="scope.row.highlight" style="color: red">{{scope.row.projectNo}}</span>
          <span v-else>{{scope.row.projectNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" align="center" label="项目名称"/>
      <el-table-column prop="customerDelivery" align=" center" label="客户到货日期" width="200px"/>
      <el-table-column prop="finalDeliveryDate" align="center" label="最终发运日期" width="200px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.finalDeliveryDate" clearable @change="saveModel(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="projectType" align="center" label="产品类型" width="100px"/>
      <el-table-column prop="packStatus" align="center" label="包装" width="100px"/>
      <el-table-column prop="createTime" align="center" label="创建时间" width="140px"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号" width="140px"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "WksDeliveryList",
    components: {VmTable, VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        importLoading: false,
        fileList: [],
        uploadUrl: window.config.basicServerUrl + "wksDeliveries/fileAnalysis",
        uploadUrlExcel: window.config.basicServerUrl + "wksDeliveries/uploadExcel",
        uploadUrlExcelByFB: window.config.basicServerUrl + "wksDeliveries/uploadExcel_fb",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          note: "",
          status: 1,
          programNo: "",
          creatorName: "",
          projectType: "",
          packStatus: "",
          factoryNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      saveModel(row) {
        this.$http
          .put("basic", "wksDeliveries", row)
          .then(() => {
            this.getList(1);
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.$message.error("保存失败");
          });
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "wksDeliveries", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "wksDeliveries/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      checksRowClassName({row}) {
        console.log(row);
        if (row.highlight) {
          return "error-row";
        } else {
          return "";
        }

      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>

<style scoped>

</style>
